import Pochta from "./Pochta";
function ISFJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
            <div className="image-wrapper" >
     <img src="/img/Защитник ISFP.png"  className="ISFJ"/>
     </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
        <h2>ISFJ</h2>
       <p><strong>Процент населения:</strong> 13–14%</p>
<p><strong>Среди мужчин:</strong> 8–10%</p>
<p><strong>Среди женщин:</strong> 17–20%</p>
<p><strong>Стратегия:</strong> Забота и поддержка</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ISFJ черпают энергию в одиночестве и заботе о близких. 
  Им нужно время, чтобы восстановить силы после общения. 
  Они восстанавливают силы в тишине, занимаясь привычными делами.
</p>
<p>
  Решения ISFJ принимают на основе чувств и личного опыта. 
  Они доверяют своей памяти и проверенным методам. 
  Они ценят гармонию, традиции и возможность помогать другим.
</p>
<p>
  Это заботливые и преданные люди. 
  Они всегда помнят детали и замечают потребности других. 
  Им трудно говорить «нет», но их доброта согревает всех вокруг.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ISFJ отдают себя без остатка и почти ничего не просят взамен. Они забывают о себе, 
  растворяются в заботе о других и не умеют говорить «нет». Их трудно сдвинуть с места, 
  и они могут застрять в зоне комфорта на годы.
</p>

<p>
  ISFJ — это человек, который помнит, что ты любишь на завтрак, и сделает это, даже если не просил. 
  Они замечают твою усталость до того, как ты сам её осознал. Они — тихая гавань, 
  куда можно вернуться после шторма. И никто не ценит их по-настоящему, пока они не исчезнут.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ISFJ;